import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: false,
  name: 'search',
})

export class SearchPipe implements PipeTransform {
  transform(items: any, filter: any, defaultFilter: boolean): any {
    if (!filter) {
      return items;
    }

    if (!Array.isArray(items)) {
      return items;
    }

    if (filter && Array.isArray(items)) {
      const filterKeys = Object.keys(filter);

      if (defaultFilter) {
        return items.filter(item =>
          filterKeys.reduce((x, keyName) =>
            (x && new RegExp(filter[keyName], 'gi').test(item[keyName])) || filter[keyName] === '', true));
      } else {
        return items.filter(item =>
          filterKeys.some(keyName =>
            new RegExp(filter[keyName], 'gi').test(item[keyName]) || filter[keyName] === ''));
      }
    }
  }
}
